import { render, staticRenderFns } from "./DepartSon.vue?vue&type=template&id=50ff3390&scoped=true&"
import script from "./DepartSon.vue?vue&type=script&lang=js&"
export * from "./DepartSon.vue?vue&type=script&lang=js&"
import style0 from "./DepartSon.vue?vue&type=style&index=0&id=50ff3390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ff3390",
  null
  
)

export default component.exports